import src from "IMAGE";
export default { src, width: 221, height: 60, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALUlEQVR42gEiAN3/ACFYIUkTMRY4JE4bTBk6IU0AHVgseCNkJWgtdCVsKWQkY3I7B4OTnIltAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 2 }
